// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"933":"backend","966":"login"}[chunkId] || chunkId) + "." + {"26":"a0053f24","375":"e1b76aaf","420":"16408955","509":"009f327d","566":"1538e79d","782":"9fca2c09","933":"819be2b2","966":"1538e79d"}[chunkId] + ".css";
};